/* eslint-disable import/no-mutable-exports */
import { useEffect, useState } from 'react'

export let SocketOpcode;
(function (SocketOpcode) {
  SocketOpcode[(SocketOpcode.Event = 0)] = 'Event'
  SocketOpcode[(SocketOpcode.Hello = 1)] = 'Hello'
  SocketOpcode[(SocketOpcode.Initialize = 2)] = 'Initialize'
  SocketOpcode[(SocketOpcode.Heartbeat = 3)] = 'Heartbeat'
})(SocketOpcode || (SocketOpcode = {}))

export let SocketEvents;
(function (SocketEvents) {
  SocketEvents.INIT_STATE = 'INIT_STATE'
  SocketEvents.PRESENCE_UPDATE = 'PRESENCE_UPDATE'
})(SocketEvents || (SocketEvents = {}))

const SAFE_DEFAULT_HEARTBEAT = 10_000

export function useLanyardWS(snowflake, userOptions) {
  const options = {
    api: {
      hostname: 'api.lanyard.rest',
      secure: true,
    },
    ...userOptions,
  }

  const [data, setData] = useState()

  const protocol = options.api.secure ? 'wss' : 'ws'
  const url = `${protocol}://${options.api.hostname}/socket`

  useEffect(() => {
    if (typeof window === 'undefined')
      return
    if (!navigator.onLine)
      return

    let heartbeat
    let socket

    function connect() {
      try {
        socket = new WebSocket(url)

        socket.addEventListener('close', connect)
        socket.addEventListener('message', message)
      }
      catch {

      }
    }

    function message(event) {
      try {
        const message = JSON.parse(event.data)

        switch (message.op) {
          case SocketOpcode.Hello: {
            heartbeat = setInterval(() => {
              try {
                if (socket?.readyState === WebSocket.OPEN) {
                  socket.send(JSON.stringify({ op: SocketOpcode.Heartbeat }))
                }
              }
              catch {}
            }, message.d?.heartbeat_interval ?? SAFE_DEFAULT_HEARTBEAT)

            try {
              if (socket?.readyState === WebSocket.OPEN) {
                socket.send(
                  JSON.stringify({
                    op: SocketOpcode.Initialize,
                    d: { subscribe_to_id: snowflake },
                  }),
                )
              }
            }
            catch {}

            break
          }

          case SocketOpcode.Event: {
            if (
              message.t === SocketEvents.INIT_STATE
              || message.t === SocketEvents.PRESENCE_UPDATE
            ) {
              if (message.d)
                setData(message.d)
            }
            break
          }

          default:
            break
        }
      }
      catch {}
    }

    connect()

    return () => {
      try {
        if (heartbeat)
          clearInterval(heartbeat)
        if (socket) {
          socket.removeEventListener('close', connect)
          socket.removeEventListener('message', message)
          if (socket.readyState === WebSocket.OPEN)
            socket.close()
        }
      }
      catch {}
    }
  }, [url, snowflake])

  return data ?? options.initialData
}
